/**
 * View component for /sentiment-answers/:sentimentAnswerId/update
 *
 * Updates a single sentimentAnswer from a copy of the selcted sentimentAnswer
 * as defined in the sentimentAnswer reducer
 */

// import primary libraries
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { history, withRouter } from 'react-router-dom';

// import third-party libraries
import _ from 'lodash';

// import actions
import * as sentimentAnswerActions from '../sentimentAnswerActions';

// import global components
import Base from "../../../global/components/BaseComponent.js.jsx";

// import module components
import SentimentAnswerForm from '../components/SentimentAnswerForm.js.jsx';
import SentimentAnswerLayout from '../components/SentimentAnswerLayout.js.jsx';

// import sentimentAnswer css modules
import sentimentAnswerStyles from '../sentimentAnswerModuleStyles.css';

class UpdateSentimentAnswer extends Base {
  constructor(props) {
    super(props);
    const { selectedSentimentAnswer, sentimentAnswerMap } = this.props;
    this.state = {
      sentimentAnswer: sentimentAnswerMap[selectedSentimentAnswer.id] ? { ...sentimentAnswerMap[selectedSentimentAnswer.id] } : {}
      // NOTE: we don't want to change the store, just make changes to a copy
    }
    this._bind(
      '_handleFormChange'
      , '_handleFormSubmit'
    );
  }

  componentDidMount() {
    const { dispatch, match } = this.props;
    dispatch(sentimentAnswerActions.fetchSingleIfNeeded(match.params.sentimentAnswerId))
  }

  componentWillReceiveProps(nextProps) {
    const { selectedSentimentAnswer, sentimentAnswerMap } = nextProps;
    this.setState({
      sentimentAnswer: sentimentAnswerMap[selectedSentimentAnswer.id] ? { ...sentimentAnswerMap[selectedSentimentAnswer.id] } : {}
      //we don't want to actually change the store's sentimentAnswer, just use a copy
    })
  }

  _handleFormChange(e) {
    let newSentimentAnswerState = _.update( this.state.sentimentAnswer, e.target.name, function() {
      return e.target.value;
    });
    this.setState({sentimentAnswer :newSentimentAnswerState});
  }

  _handleFormSubmit(e) {
    const { dispatch, history } = this.props;
    e.preventDefault();
    dispatch(sentimentAnswerActions.sendUpdateSentimentAnswer(this.state.sentimentAnswer)).then((action) => {
      if(action.success) {
        history.push(`/sentiment-answers/${action.item._id}`)
      } else {
        // console.log("Response Error:");
        // console.log(action);
        alert("ERROR - Check logs");
      }
    });
  }

  render() {
    const { selectedSentimentAnswer, sentimentAnswerMap } = this.props;
    const { sentimentAnswer } = this.state;
    const isEmpty = (!sentimentAnswer || sentimentAnswer._id === null || sentimentAnswer._id === undefined);
    return  (
      <SentimentAnswerLayout>
        <div className="flex">
          <section className="section">
            {isEmpty ?
              (selectedSentimentAnswer.isFetching ? <h2>Loading...</h2> : <h2>Empty.</h2>)
              :
              <SentimentAnswerForm
                sentimentAnswer={sentimentAnswer}
                cancelLink={`/sentiment-answers/${sentimentAnswer._id}`}
                formTitle="Update SentimentAnswer"
                formType="update"
                handleFormChange={this._handleFormChange}
                handleFormSubmit={this._handleFormSubmit}
              />
            }
          </section>
        </div>
      </SentimentAnswerLayout>
    )
  }
}

UpdateSentimentAnswer.propTypes = {
  dispatch: PropTypes.func.isRequired
}

const mapStoreToProps = (store) => {
  /**
  * NOTE: Yote refer's to the global Redux 'state' as 'store' to keep it mentally
  * differentiated from the React component's internal state
  */
  return {
    selectedSentimentAnswer: store.sentimentAnswer.selected
    , sentimentAnswerMap: store.sentimentAnswer.byId
  }
}

export default withRouter(
  connect(
    mapStoreToProps
  )(UpdateSentimentAnswer)
);



// WEBPACK FOOTER //
// modules/sentimentAnswer/views/UpdateSentimentAnswer.js.jsx